<div class="infonavit-wrap" *ngIf="!loading">
    <div class="infonavit-summary-row">
        <div class="infonavit-summary-card infonavit-summary-card-wide">
            <div class="infonavit-summary-icon" style="background:#fee7f7;"><img src="assets/img/icons/infonavit-money-bag.svg" alt=""></div>
            <div class="infonavit-summary-text">
                <p class="label">Estado del crédito</p>
                <p class="value">{{creditStateLabel}}</p>
                <p class="sublabel">{{creditStateSubtext}}</p>
            </div>
        </div>
        <div class="infonavit-summary-card">
            <div class="infonavit-summary-icon" style="background:#dcfce7;"><img src="assets/img/icons/infonavit-tipo-credito.svg" alt=""></div>
            <div class="infonavit-summary-text">
                <p class="label">Tipo de crédito</p>
                <p class="value">{{creditTypeLabel}}</p>
            </div>
        </div>
        <div class="infonavit-summary-card">
            <div class="infonavit-summary-icon" style="background:#ffedd4;"><img src="assets/img/icons/infonavit-descuento.svg" alt=""></div>
            <div class="infonavit-summary-text">
                <p class="label">Descuento mensual</p>
                <p class="value">{{monthlyDiscountLabel}}</p>
            </div>
        </div>
        <div class="infonavit-summary-card">
            <div class="infonavit-summary-icon" style="background:#c1eef0;"><img src="assets/img/icons/infonavit-ultimo-movimiento.svg" alt="" class="infonavit-icon-wide"></div>
            <div class="infonavit-summary-text">
                <p class="label">Ultimo movimiento</p>
                <p class="value">{{lastMovementLabel}}</p>
            </div>
        </div>
    </div>

    <div class="infonavit-actions-row">
        <button type="button" class="infonavit-btn-primary" *ngIf="!credit && canDo('Editar')" (click)="openModal()">
            <i class="ti ti-plus"></i> Registrar crédito
        </button>
        <div class="infonavit-options-dropdown" (click)="$event.stopPropagation()">
            <button type="button" class="infonavit-btn-outline" (click)="toggleActionsDropdown()">
                <img src="assets/img/icons/icon-more-options.svg" alt=""> Opciones
            </button>
            <ul class="dropdown-menu infonavit-options-menu" [class.show]="actionsOpen">
                <li><button class="dropdown-item" type="button" (click)="exportCsv()">Exportar CSV</button></li>
            </ul>
        </div>
        <button type="button" class="infonavit-btn-outline infonavit-export-btn" (click)="exportCsv()">
            <img src="assets/img/icons/icon-download.svg" alt=""> Exportar historial
        </button>
    </div>

    <div class="infonavit-empty-hero" *ngIf="!credit">
        <div class="infonavit-empty-icon"><img src="assets/img/icons/infonavit-home-empty.svg" alt=""></div>
        <div class="infonavit-empty-text">
            <p class="title">Este trabajador no tiene créditos INFONAVIT registrados.</p>
            <p class="desc">Los créditos INFONAVIT registrados se utilizan para calcular automáticamente las retenciones de nómina correspondientes.</p>
            <button type="button" class="infonavit-btn-primary" *ngIf="canDo('Editar')" (click)="openModal()">
                <i class="ti ti-plus"></i> Registrar crédito
            </button>
        </div>
    </div>

    <div class="infonavit-bottom-row">
        <div class="infonavit-bottom-col">
            <ng-container *ngIf="credit; else creditHistoryEmpty">
                <p class="infonavit-section-title">Detalle del crédito</p>
                <div class="infonavit-detail-card">
                    <div class="infonavit-detail-field"><span class="label">Clave Per.Ded.:</span><span class="value">{{credit.per_ded_key || '--'}}</span></div>
                    <div class="infonavit-detail-field"><span class="label">Número de crédito:</span><span class="value">{{credit.credit_number || '--'}}</span></div>
                    <div class="infonavit-detail-field"><span class="label">Aplicación a nómina:</span><span class="value">{{payrollApplicationLabel(credit.payroll_application)}}</span></div>
                    <div class="infonavit-detail-field"><span class="label">Vigencia:</span><span class="value">{{formatDate(credit.start_date)}} - {{credit.end_date ? formatDate(credit.end_date) : 'Sin fecha de término'}}</span></div>
                    <div class="infonavit-detail-field"><span class="label">Monto o fórmula:</span><span class="value">{{credit.formula_or_amount || '--'}}</span></div>
                    <div class="infonavit-detail-field"><span class="label">Monto límite:</span><span class="value">{{credit.amount_limit ? formatCurrency(credit.amount_limit) : 'Sin límite'}}</span></div>
                    <div class="infonavit-detail-field"><span class="label">Referencia para el cálculo:</span><span class="value">{{calculationReferenceLabel(credit.calculation_reference)}}</span></div>
                </div>
            </ng-container>
            <ng-template #creditHistoryEmpty>
                <p class="infonavit-section-title">Historial de créditos</p>
                <div class="infonavit-history-empty">
                    <img src="assets/img/icons/icon-folder.svg" alt="">
                    <p class="msg">No hay créditos registrados.</p>
                    <a *ngIf="canDo('Editar')" href="javascript:void(0)" (click)="openModal()">Registrar crédito</a>
                </div>
            </ng-template>
        </div>
        <div class="infonavit-bottom-col">
            <p class="infonavit-section-title">Línea de tiempo</p>
            <div class="infonavit-timeline">
                <div class="infonavit-timeline-item">
                    <div class="infonavit-timeline-icon-col">
                        <div class="infonavit-timeline-icon" style="background:#ccffdf;"><img src="assets/img/icons/infonavit-timeline-home.svg" alt=""></div>
                        <span class="infonavit-timeline-connector"></span>
                    </div>
                    <div class="infonavit-timeline-text">
                        <p class="title">{{latestGrantEvent ? 'Crédito otorgado' : 'Sin eventos registrados'}}</p>
                        <p class="desc">{{latestGrantEvent ? (formatDate(latestGrantEvent.date) + ' — ' + latestGrantEvent.detail) : 'Aún no existen eventos para mostrar.'}}</p>
                    </div>
                </div>
                <div class="infonavit-timeline-item">
                    <div class="infonavit-timeline-icon-col">
                        <div class="infonavit-timeline-icon" style="background:#ffedd4;"><img src="assets/img/icons/infonavit-timeline-percent.svg" alt=""></div>
                        <span class="infonavit-timeline-connector"></span>
                    </div>
                    <div class="infonavit-timeline-text">
                        <p class="title">{{latestDiscountEvent ? 'Descuento aplicado' : 'Sin descuentos registrados'}}</p>
                        <p class="desc">{{latestDiscountEvent ? (formatDate(latestDiscountEvent.date) + ' — ' + latestDiscountEvent.detail) : 'No se han aplicado descuentos INFONAVIT.'}}</p>
                    </div>
                </div>
                <div class="infonavit-timeline-item">
                    <div class="infonavit-timeline-icon-col">
                        <div class="infonavit-timeline-icon" style="background:#e2d5f6;"><img src="assets/img/icons/infonavit-timeline-edit-off.svg" alt=""></div>
                    </div>
                    <div class="infonavit-timeline-text">
                        <p class="title">{{latestModificationEvent ? 'Crédito modificado' : 'Sin modificaciones'}}</p>
                        <p class="desc">{{latestModificationEvent ? (formatDate(latestModificationEvent.date) + ' — ' + latestModificationEvent.detail) : 'No hay modificaciones en el crédito.'}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="hist-empty-state" *ngIf="loading">
    <i class="ti ti-loader-2"></i>
    <p class="mb-0">Cargando información de crédito INFONAVIT...</p>
</div>

<div class="hist-empty-state" *ngIf="!loading && loadError">
    <i class="ti ti-file-x"></i>
    <p class="mb-0">No se pudo cargar la información de crédito INFONAVIT.</p>
</div>

<div class="modal fade" id="infonavitCreditModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered infonavit-modal-dialog">
        <div class="modal-content infonavit-modal-content">
            <button type="button" class="infonavit-modal-close" (click)="closeModal()" aria-label="Cerrar">
                <img src="assets/img/icons/icon-x-close.svg" alt="">
            </button>
            <h4 class="infonavit-modal-title">Registrar credito</h4>

            <form [formGroup]="form" (ngSubmit)="save()">
                <div class="infonavit-modal-box">
                    <div class="infonavit-form-columns">
                        <div class="infonavit-form-col">
                            <p class="infonavit-form-section-label">Datos del trabajador</p>
                            <div class="field-row">
                                <div class="field-col">
                                    <label class="field-label">Nombre el trabajador</label>
                                    <input type="text" class="field-input infonavit-input-readonly" [value]="employeeFullName" readonly>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="field-col">
                                    <label class="field-label">Tipo de empleado</label>
                                    <div class="field-input-icon-wrap" [class.is-invalid]="submitted && f['credit_type'].invalid">
                                        <input type="text" formControlName="credit_type">
                                        <img src="assets/img/icons/icon-circle-help.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="field-col">
                                    <label class="field-label">Clave Per.Ded.</label>
                                    <div class="field-input-icon-wrap" [class.is-invalid]="submitted && f['per_ded_key'].invalid">
                                        <input type="text" formControlName="per_ded_key">
                                        <img src="assets/img/icons/icon-circle-help.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="field-col">
                                    <label class="field-label">Número de crédito (Opcional)</label>
                                    <input type="text" class="field-input" placeholder="Ej. 12345678901" formControlName="credit_number">
                                </div>
                            </div>
                        </div>
                        <div class="infonavit-vertical-divider"></div>
                        <div class="infonavit-form-col">
                            <p class="infonavit-form-section-label">Aplicar a nómina</p>
                            <p class="infonavit-form-section-hint">Selecciona cómo se aplicará este crédito</p>
                            <div class="infonavit-radio-card" *ngFor="let opt of payrollApplicationOptions"
                                [class.active]="form.value.payroll_application === opt.value"
                                (click)="selectPayrollApplication(opt.value)">
                                <div class="infonavit-radio-card-icon" [style.background]="opt.bg">
                                    <img [src]="'assets/img/icons/' + opt.icon" alt="">
                                </div>
                                <div class="infonavit-radio-card-text">
                                    <p class="title">{{opt.label}}</p>
                                    <p class="desc">{{opt.desc}}</p>
                                </div>
                                <span class="infonavit-radio-dot" [class.checked]="form.value.payroll_application === opt.value"></span>
                            </div>
                        </div>
                    </div>

                    <hr class="infonavit-divider">

                    <p class="infonavit-form-section-label mb-0">Vigencia del crédito</p>
                    <div class="field-row align-items-end">
                        <div class="field-col">
                            <label class="field-label">Fecha de inicio</label>
                            <div class="field-input-icon-wrap" [class.is-invalid]="submitted && f['start_date'].invalid">
                                <app-date-picker formControlName="start_date"></app-date-picker>
                            </div>
                        </div>
                        <div class="field-col">
                            <label class="field-label">Fecha de término</label>
                            <div class="field-input-icon-wrap">
                                <app-date-picker formControlName="end_date"></app-date-picker>
                            </div>
                        </div>
                        <div class="field-col">
                            <div class="infonavit-info-box">
                                <img src="assets/img/icons/icon-info-circle.svg" alt="">
                                <span>Si no especificas fecha de términol, el descuento se aplicará hasta que se liquide el crédito.</span>
                            </div>
                        </div>
                    </div>

                    <hr class="infonavit-divider">

                    <p class="infonavit-form-section-label">Montos</p>
                    <p class="infonavit-form-section-hint">Define el monto o fórmula del descuento y el limite aplicable</p>
                    <div class="infonavit-montos-row">
                        <div class="infonavit-montos-grid">
                            <div class="field-col">
                                <label class="field-label">Monto o fómula</label>
                                <div class="field-input-icon-wrap" [class.is-invalid]="submitted && f['formula_or_amount'].invalid">
                                    <input type="text" formControlName="formula_or_amount">
                                    <img src="assets/img/icons/icon-circle-help.svg" alt="">
                                </div>
                            </div>
                            <div class="field-col">
                                <label class="field-label">Valor de descuento</label>
                                <div class="field-input-icon-wrap" [class.is-invalid]="submitted && f['discount_value'].invalid">
                                    <input type="number" step="0.01" formControlName="discount_value">
                                    <img src="assets/img/icons/icon-calculator.svg" alt="">
                                </div>
                            </div>
                            <div class="field-col">
                                <label class="field-label">Monto limite (Opcional)</label>
                                <div class="field-input-icon-wrap infonavit-input-muted">
                                    <input type="number" step="0.01" formControlName="amount_limit">
                                    <img src="assets/img/icons/icon-calculator.svg" alt="">
                                </div>
                            </div>
                            <div class="field-col">
                                <label class="field-label">Monto acumulado (Informativo)</label>
                                <div class="field-input-icon-wrap infonavit-input-muted">
                                    <input type="text" value="0.00" readonly>
                                    <img src="assets/img/icons/icon-calculator.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="infonavit-calc-reference">
                            <p class="infonavit-calc-reference-title">Referencia para el cálculo</p>
                            <label class="infonavit-radio-inline" *ngFor="let opt of calculationReferenceOptions; let i = index">
                                <input type="radio" name="calculation_reference" [value]="opt.value" formControlName="calculation_reference">
                                <span class="infonavit-radio-inline-text">{{i + 1}}. {{opt.label}}</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="infonavit-modal-actions">
                    <button type="button" class="infonavit-btn-secondary" (click)="closeModal()">Cancelar</button>
                    <button type="submit" class="infonavit-btn-primary" *ngIf="canDo('Editar')">Registrar</button>
                </div>
            </form>
        </div>
    </div>
</div>
